import { TaskTypeId } from "@sp-crm/core";
import React from "react";
import { useActivityTypeOptions } from "./activity-type-options";

interface NamedActivityType {
    id: TaskTypeId;
    name: string;
}

export const activityTypeName = (
    activityTypes: NamedActivityType[],
    activityTypeId: TaskTypeId | null,
): string | null => {
    if (!activityTypeId) {
        return null;
    }
    return (
        activityTypes.find(activityType => activityType.id === activityTypeId)?.name ??
        null
    );
};

export const listedActivityTypeName = (
    activityTypes: NamedActivityType[],
    activityType: NamedActivityType,
): string => activityTypeName(activityTypes, activityType.id) ?? activityType.name;

export const useActivityTypeName = (activityTypeId: TaskTypeId | null): string | null =>
    activityTypeName(useActivityTypeOptions(), activityTypeId);

export const useListedActivityTypeName = (
    activityType: NamedActivityType | null,
): string | null => {
    const activityTypes = useActivityTypeOptions();
    return activityType ? listedActivityTypeName(activityTypes, activityType) : null;
};

export const ActivityTypeLabel: React.FC<{ activityTypeId: TaskTypeId | null }> = ({
    activityTypeId,
}) => {
    const name = useActivityTypeName(activityTypeId);
    if (!name) {
        return null;
    }
    return (
        <div className="text-sm text-gray-500">
            Activity type: <span className="font-medium text-gray-700">{name}</span>
        </div>
    );
};
